import { t as gsapWithCSS } from "@theme/gsap";
import { t as ensureScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/science-table-of-contents.js
var ScienceTableOfContents = class extends HTMLElement {
	async connectedCallback() {
		const columns = Array.from(this.querySelectorAll(":scope > ul > *"));
		if (!columns.length) return;
		const entryDelay = parseFloat(this.dataset.delay ?? "0");
		const parts = columns.map((col) => Array.from(col.children));
		if (this._played) {
			gsapWithCSS.set(parts, {
				opacity: 1,
				visibility: "visible"
			});
			return;
		}
		gsapWithCSS.set(parts, {
			opacity: 0,
			x: -10,
			visibility: "visible"
		});
		const ScrollTrigger = await ensureScrollTrigger();
		const stagger = .1;
		const colDuration = 1;
		const partGap = .1;
		let prevEndsAt = 0;
		this._triggers = columns.map((col, i) => ScrollTrigger.create({
			trigger: col,
			start: "top 95%",
			onEnter: () => {
				const now = performance.now();
				const crossColumnDelay = Math.max(0, (prevEndsAt - now) / 1e3);
				const delay = (i === 0 ? entryDelay : 0) + crossColumnDelay;
				prevEndsAt = now + (delay + (parts[i].length - 1) * partGap + stagger) * 1e3;
				gsapWithCSS.to(parts[i], {
					opacity: 1,
					x: 0,
					duration: colDuration,
					ease: "power3.out",
					delay,
					stagger: partGap
				});
			}
		}));
		this._played = true;
	}
	disconnectedCallback() {
		this._triggers?.forEach((t) => t.kill());
	}
};
customElements.define("science-table-of-contents", ScienceTableOfContents);
//#endregion
